/**
 * In-product brand strings — single source of truth.
 *
 * Surfaces the AI-stack composition consistently in source attribution
 * lines (SED references, report appendices, section headers). Edit here
 * and every consumer updates without a sweep.
 */

/** The AI stack identifier shown in user-facing attributions. Order
 *  reflects the request flow: Gemini does the inference, the Deep
 *  Atomic prompt-engineering layer shapes it, Google Search grounds it. */
export const AI_STACK_LABEL = 'Gemini + Datacrate Model + Google Search';

/** Long form including the model version. Used where users care about
 *  exactly which Gemini variant produced the answer (cached vs fresh
 *  attributions in siteResearch). */
export const AI_STACK_LABEL_VERSIONED = 'Gemini 2.5 Pro + Datacrate Model + Google Search';
